import {
  DEFAULT_TASK_TYPE,
  TASK_TYPE_STORY,
  TASK_TYPE_TASK,
  TASK_TYPE_SUBTASK,
  TASK_TYPE_BUG,
  TASK_TYPE_RESEARCH,
  TASK_TYPE_DOCUMENTATION,
  TASK_TYPE_ANALYSIS
} from '../constants/taskTypes';

// Helper function to format due date
export const formatDueDate = (dueDate) => {
  if (!dueDate) return null;
  const date = new Date(dueDate);
  const now = new Date();
  const diffTime = date - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays < 0) {
    return { text: `${Math.abs(diffDays)}d overdue`, status: 'overdue' };
  } else if (diffDays === 0) {
    return { text: 'Due today', status: 'due-today' };
  } else if (diffDays <= 3) {
    return { text: `${diffDays}d left`, status: 'urgent' };
  } else if (diffDays <= 7) {
    return { text: `${diffDays}d left`, status: 'upcoming' };
  } else {
    return { text: date.toLocaleDateString(), status: 'normal' };
  }
};

// Helper function to get task type icon and styling
export const getTaskTypeConfig = (taskType) => {
  const type = taskType || DEFAULT_TASK_TYPE;
  switch (type) {
    case TASK_TYPE_STORY:
      return {
        icon: 'story',
        bgColor: '#faf5ff',
        iconColor: '#7c3aed',
        borderColor: '#e9d5ff'
      };
    case TASK_TYPE_SUBTASK:
      return {
        icon: 'subtask',
        bgColor: '#f1f5f9',
        iconColor: '#64748b',
        borderColor: '#cbd5e1'
      };
    case TASK_TYPE_BUG:
      return {
        icon: 'bug',
        bgColor: '#fef2f2',
        iconColor: '#dc2626',
        borderColor: '#fecaca'
      };
    case TASK_TYPE_RESEARCH:
      return {
        icon: 'research',
        bgColor: '#f5f3ff',
        iconColor: '#7c3aed',
        borderColor: '#ddd6fe'
      };
    case TASK_TYPE_DOCUMENTATION:
      return {
        icon: 'documentation',
        bgColor: '#eff6ff',
        iconColor: '#2563eb',
        borderColor: '#bfdbfe'
      };
    case TASK_TYPE_ANALYSIS:
      return {
        icon: 'analysis',
        bgColor: '#f0fdf4',
        iconColor: '#059669',
        borderColor: '#bbf7d0'
      };
    case TASK_TYPE_TASK:
    default:
      return {
        icon: 'task',
        bgColor: '#f8fafc',
        iconColor: '#475569',
        borderColor: '#e2e8f0'
      };
  }
};

